// NOTE: https://myosh.atlassian.net/browse/MYOSH-8345?focusedCommentId=64601
export const criticalFilterValues = {
  truthy: 'Critical',
  falsy: 'Non Critical',
};

export const effectiveFilterValues = {
  truthy: 'Effective',
  falsy: 'Not Effective',
};

export const initialImplementationRequiredValues = {
  truthy: 'Yes',
  falsy: 'No',
};

export const materialRiskRelationValues = {
  truthy: 'Yes',
  falsy: 'No',
};

export const DIAGRAM_MODE = {
  BOWTIE: 'BOWTIE',
  BUTTERFLY: 'BUTTERFLY',
} as const;
export type DIAGRAM_MODE = (typeof DIAGRAM_MODE)[keyof typeof DIAGRAM_MODE];

// TEMPORARY stopgap: the v4 BowtieDTO has no escalation factor support, so the
// "Create Backend Records" flow follows up the job with a FE-driven create of
// EF + EFB records. Remove once the backend supports EFs natively (or the EF
// graph-structure redesign forces a deeper rework). Flip to `false` to revert
// to the prior behaviour (EFs / EFBs lost on Create Backend Records).
export const BOWTIE_TEMP_EF_BACKEND_CREATION_ENABLED = true;
